var React = require('react');

var Alert = require('patternity/lib/alert');

var Errors = React.createClass({
  propTypes: {
    errorMsg: React.PropTypes.string
  },

  render: function() {
    if(this.props.errorMsg === null) {
      return null;
    }

    return (
      <div style={this.styles.error}>
        <Alert type="error" showIcon={true} title={this.props.errorMsg}></Alert>
      </div>
    );
  },

  styles: {
    error: {
      marginBottom: '10px'
    }
  }
});

module.exports = Errors;



// WEBPACK FOOTER //
// ./src/advocate/stages/quiz/components/errors.jsx